module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plthumb",
    class: {
      grid: !_vm.fullsizeview, full: _vm.fullsizeview, initialized: !_vm.hoverLock, addedtosheet: _vm.photoAddedToSheet
    },
    on: {
      "mouseover": function($event) {
        _vm.initializeCarousel = true
      },
      "touchstart": function($event) {
        _vm.initializeCarousel = true
      }
    }
  }, [(_vm.difficulty) ? _c('div', {
    staticClass: "difficulty-indicators"
  }, [_c('div', {
    staticClass: "frequency",
    class: [_vm.difficulty.frequency]
  }), _vm._v(" "), _c('div', {
    staticClass: "price",
    class: [_vm.difficulty.price]
  }), _vm._v(" "), _c('div', {
    staticClass: "usability",
    class: [_vm.difficulty.usability]
  })]) : _vm._e(), _vm._v(" "), (_vm.initializeCarousel) ? _c('div', {
    staticClass: "overlay-container"
  }, [(_vm.showpullsheet) ? _c('div', {
    staticClass: "bottom-overlay",
    on: {
      "click": function($event) {
        _vm.addToPullSheet(_vm.photoAddedToSheet)
      }
    }
  }, [(!_vm.photoAddedToSheet) ? _c('span', [_vm._v("Add")]) : _c('span', {
    staticClass: "added"
  }, [_vm._v("Added")]), _vm._v(" "), _c('div', {
    staticClass: "pullsheet-tooltip",
    class: {
      added: _vm.photoAddedToSheet
    }
  }, [(!_vm.photoAddedToSheet) ? _c('span', [_vm._v("To Pullsheet")]) : _c('span', {
    staticClass: "added"
  }, [_vm._v("To Pullsheet")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "next-button"
  }, [_c('i', {
    staticClass: "material-icons",
    on: {
      "click": _vm.advanceCarousel
    }
  }, [_vm._v("keyboard_arrow_right")])]), _vm._v(" "), _c('div', {
    staticClass: "previous-button"
  }, [_c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        _vm.advanceCarousel("backward")
      }
    }
  }, [_vm._v("keyboard_arrow_left")])])]) : _vm._e(), _vm._v(" "), (_vm.initializeCarousel) ? _c('carousel', {
    ref: "carousel",
    attrs: {
      "perPage": 1,
      "paginationEnabled": false,
      "loop": true
    },
    on: {
      "pageChange": _vm.carouselPageChange
    }
  }, _vm._l((_vm.filteredphotos), function(photo, index) {
    return _c('slide', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "to": "/location/" + _vm.PL.plno
      }
    }, [_c('img', {
      attrs: {
        "src": 'https://img.productionlocations.com/' + photo.u
      }
    })])], 1)
  })) : _vm._e(), _vm._v(" "), (!_vm.initializeCarousel && _vm.lazy) ? _c('router-link', {
    attrs: {
      "to": "/location/" + _vm.PL.plno
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('https://img.productionlocations.com/' + _vm.filteredphotos[0].u),
      expression: "'https://img.productionlocations.com/'+filteredphotos[0].u"
    }]
  })]) : _vm._e(), _vm._v(" "), (!_vm.initializeCarousel && !_vm.lazy) ? _c('router-link', {
    attrs: {
      "to": "/location/" + _vm.PL.plno
    }
  }, [_c('img', {
    attrs: {
      "src": 'https://img.productionlocations.com/' + _vm.filteredphotos[0].u
    }
  })]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("PL" + _vm._s(_vm.PL.plno))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e7e184b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PLThumb.vue
// module id = 194
// module chunks = 1